import { useContext, useEffect } from "react";
import { AuthContext } from "../../contexts/Authentication/AuthContext";
import { DashboardProvider } from "../../contexts/Dashboard/DashboardContext";
import HeaderTower from "./Header";
import DashboardMain from "./Main";
import sendDataToCustomerX from "../../services/customerXTracking";

const Dashboard = () => {
  const { isAuthenticated, hasShortToken} = useContext(AuthContext);


  useEffect(() => {
    if(isAuthenticated || hasShortToken){
      sendDataToCustomerX("dashboardsTLE");
    }
  }, []);

  return (
    <DashboardProvider>
      {isAuthenticated || hasShortToken ? (
        <HeaderTower>
          <DashboardMain />
        </HeaderTower>
      ) : (
        <></>
      )}
    </DashboardProvider>
  );
};
export default Dashboard;
